import InterestRateType from "@/models/Products/InterestRateType";

export default (interestRateType: InterestRateType) => {
    let returnVal = "Undefined";
    switch (interestRateType) {
        case InterestRateType.Fixed:
            returnVal = "Fixed"
            break;
        case InterestRateType.Variable:
            returnVal = "Variable"
            break;
    }
    return returnVal;
}